import Marquee from "react-fast-marquee";

const DEFAULT_WORDS = [
  "Reliable",
  "Affordable",
  "Professional",
  "Fully Insured",
  "DBS Checked",
  "Satisfaction Guaranteed",
  "Mobile Service",
];

export default function EditorialMarquee({ words = DEFAULT_WORDS, dark = false }) {
  return (
    <div
      data-testid="editorial-marquee"
      className={`py-6 border-y ${dark ? "bg-navy border-white/10" : "bg-mist border-black/5"}`}
    >
      <Marquee speed={38} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-heading text-2xl sm:text-3xl tracking-tight px-8 ${
                dark ? "text-white" : "text-navy"
              }`}
            >
              {w}
            </span>
            <span className="text-brandgreen text-2xl">&bull;</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
